import cacheSessionStorage from '../cache/cacheSessionStorage';
var getters = {
  age: function age(state) {
    return state.age;
  }
};
var state = {
  age: cacheSessionStorage.get('age', 18)
};
var mutations = {
  SET_AGE: function SET_AGE(state, age) {
    state.age = age;
    cacheSessionStorage.set('age', age);
  }
};
var actions = {};
export default {
  namespaced: true,
  getters: getters,
  state: state,
  mutations: mutations,
  actions: actions
};